import { LoadUserNextExpiration } from "../../domain/use-case/LoadUserNextExpiration";
import { HttpGetClient } from "../protocols/adapters/HttpGetClient";

export class RemoteLoadUserExpiration implements LoadUserNextExpiration {
  private readonly httpClient: HttpGetClient

  constructor(httpClient: HttpGetClient) {
    this.httpClient = httpClient
  }

  async handle (params: LoadUserNextExpiration.Params): Promise<LoadUserNextExpiration.Result> {
    const token = localStorage.getItem('token')
    const response = await this.httpClient.get({
      url: `/expirations/${params.userId}`,
      data: { catalogId: params.catalogId },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  }
}